import {
  Modal,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  Pressable,
} from "react-native";
import React from "react";
import {
  SafeAreaProvider,
  useSafeAreaInsets,
} from "react-native-safe-area-context";
import Cross from "@assets/svg/Cross";
import t from "@constants/localization";

const PATH = "screens/MyTask";

type Props = {
  showSarvModal: boolean;
  setShowSarvModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const SarvCallModalContent = ({ setShowSarvModal }: Props) => {
  // Insets from the SafeAreaProvider nested inside the Modal (wrapper below),
  // so this reflects the modal's own translucent window. The root provider
  // reports bottom: 0 while a navigationBarTranslucent modal is open, clipping
  // content behind the soft-nav bar.
  const insets = useSafeAreaInsets();
  return (
    <View style={styles.sarvModalBackdrop}>
      <Pressable
        style={StyleSheet.absoluteFill}
        onPress={() => setShowSarvModal(false)}
      />
      <View
        style={[
          styles.sarvModalContainer,
          { paddingBottom: insets.bottom + 16 },
        ]}
      >
        <TouchableOpacity
          style={styles.sarvModalClose}
          onPress={() => setShowSarvModal(false)}
        >
          <Cross width={10} height={10} fill="#444" />
        </TouchableOpacity>
        <Text style={styles.sarvModalText}>
          {t(`${PATH}/sarv_calling_text`)}
        </Text>
      </View>
    </View>
  );
};

const SarvCallModal = (props: Props) => {
  return (
    <Modal
      visible={props.showSarvModal}
      transparent
      animationType="slide"
      onRequestClose={() => props.setShowSarvModal(false)}
      statusBarTranslucent
      navigationBarTranslucent
    >
      {/* Nested provider measures the modal's own translucent window so
          useSafeAreaInsets() reports the real nav-bar inset inside the Modal. */}
      <SafeAreaProvider>
        <SarvCallModalContent {...props} />
      </SafeAreaProvider>
    </Modal>
  );
};

export default SarvCallModal;

import { colors } from "@constants/theme";

const styles = StyleSheet.create({
  sarvModalBackdrop: {
    flex: 1,
    backgroundColor: colors.mediumBlacklightBlack,
    justifyContent: "flex-end",
    alignItems: "center",
  },
  sarvModalContainer: {
    backgroundColor: colors.white,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    width: "100%",
    position: "absolute",
    bottom: 0,
    minHeight: 140,
    padding: 16,
    alignItems: "center",
  },
  sarvModalClose: {
    position: "absolute",
    right: 10,
    top: -35,
    backgroundColor: colors.white,
    borderRadius: 50,
    zIndex: 1,
    padding: 6,
    elevation: 2,
    shadowColor: colors.black,
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
  },
  sarvModalText: {
    marginTop: 24,
    textAlign: "center",
    color: colors.mediumBlack,
    fontSize: 16,
  },
});
